export const navItems = [
  { path: '/', label: 'Home', icon: 'home' },
  { path: '/about', label: 'About', icon: 'info' },
  { path: '/contact', label: 'Contact', icon: 'mail' },
  { path: '/faq', label: 'FAQ', icon: 'help' },
  // { path: '/request', label: 'Reach Out', icon: 'send' },
  // Temporarily hidden - Home page now has grid layout
  // { path: '/browse', label: 'Browse', icon: 'search' },
];

export const accountItems = [
  { path: '/bookmarks', label: 'Bookmarks', icon: 'bookmark' },
  { path: '/orderhistory', label: 'Order History', icon: 'receipt_long' },
  { path: '/profile', label: 'Profile', icon: 'person' },
  { path: '/cart', label: 'Cart', icon: 'shopping_cart' },
];
